// extracted by mini-css-extract-plugin
export default {"button":"Button_button__z0B-B","button_secondary":"Button_button_secondary__LOvgq","button_link":"Button_button_link__NZdf3","button_withIcon":"Button_button_withIcon__QJUEU"};